<template>
  <q-dialog v-model="showModal" persistent>
    <q-card>
      <q-card-section>
        <slot name="header">
          <div class="text-h6"><q-icon :name="icon" color="orange" size="20px"/> Caution</div>
        </slot>
      </q-card-section>

      <q-card-section>
        <slot name="default">Are you sure?</slot>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat :label="cancelBtnLabel" color="primary" v-close-popup @click="$emit('cancel')"/>
        <q-btn flat :label="okBtnLabel" color="primary" v-close-popup @click="$emit('confirm')"/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
export default {
  name: 'ConfirmationModal',
  model: {
    prop: 'open',
    event: 'change'
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'fa fa-exclamation-triangle'
    },
    okBtnLabel: {
      type: String,
      default: 'OK'
    },
    cancelBtnLabel: {
      type: String,
      default: 'Cancel'
    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.open
      },
      set: function (value) {
        this.$emit('change', value)
      }
    }
  },
  data () {
    return {}
  },
  methods: {},
  created () {

  },
  mounted () {

  },
  components: {}
}
</script>
<style>

</style>
